//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AssociatedObjects",0,"SelectNXObjectList",0],[0,"Scope",1,0],[1,"Scopedbodies",0,"ScCollector",0]],[[["types"],"EnablePmitypes",{},1,0],[["types"],"DisablePmitypes",{},1,0],[["types"],"EnableFeaturetypes",{},1,0],[["types"],"DisableFeaturetypes",{},1,0],[[],"GetFcfCriteria",{R_:{fcfCriteria:"MBD.PMIQueryFCFCriteriaBuilder"}},0,0],[[],"GetDimensionCriteria",{R_:{dimensionCriteria:"MBD.PMIQueryDimensionCriteriaBuilder"}},0,0],[[],"GetDatumCriteria",{R_:{datumCriteria:"MBD.PMIQueryDatumCriteriaBuilder"}},0,0],[[],"GetSfsCriteria",{R_:{sfsCriteria:"MBD.PMIQuerySFSCriteriaBuilder"}},0,0]],[]];
SPLM.MBD.PMIQueryBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.PMIQueryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MBD.PMIQueryBuilder.ContextScope = Object.freeze({
    "Work" : "Work", "Bodies" : "Bodies", "AssociatedObjects" : "AssociatedObjects"});

SPLM.MBD.PMIQueryBuilder.PmiType = Object.freeze({
    "Default" : "Default", "Fcf" : "Fcf", "Datum" : "Datum", "Sfs" : "Sfs", "Dimension" : "Dimension"});

SPLM.MBD.PMIQueryBuilder.FeatureType = Object.freeze({
    "Default" : "Default", "Hole" : "Hole", "Slot" : "Slot", "Surface" : "Surface", "Plane" : "Plane"});

export default SPLM;